export type LanguageCode = 'sv' | 'en';
export const DEFAULT_LOCALE = 'sv';

export enum TranslationKey {
  uiButtonNext = 'ui.ButtonNext',
  uiButtonBack = 'ui.ButtonBack',
  uiButtonGoBack = 'ui.ButtonGoBack',
  uiStartTitle = 'ui.StartTitle',
  uiBeginLegimitize = 'ui.BeginLegimitize',
  uiBeginLegimitizeNoEid = 'ui.BeginLegimitizeNoEid',
  uiSpecify = 'ui.Specify',
  uiSpecifyCountry = 'ui.SpecifyCountry',
  uiPersonalIdNumber = 'ui.PersonalIdNumber',
  uiUnspecifiedError = 'ui.UnspecifiedError',
  uiTryOnAnotherDeviceMessage = 'ui.TryOnAnotherDeviceMessage',
  uiSubmit = 'ui.Apply',
  uiEdit = 'ui.Edit',
  uiCancel = 'ui.Cancel',
  uiLogin = 'ui.Login',
  uiOpenCgiApp = 'ui.OpenCGIApp',
  uiTryAgain = 'ui.TryAgain',
  uiClickHere = 'ui.ClickHere',
  cgiSignInTitle = 'cgiSignInTitle',
  cgiDescription = 'cgiDescription',
  cgiSignInProgress = 'cgiSignInProgress',
  cgidAnotherStep1 = 'cgidAnotherStep1',
  cgidAnotherStep2 = 'cgidAnotherStep2',
  cgidAnotherStep3 = 'cgidAnotherStep3',
  cgiFreja = 'cgi.Freja',
  cgiBankId = 'cgi.BankId',
  errorRequired = 'error.Required',
  errorInvalidEmail = 'error.InvalidEmail',
  errorOneOfPayments = 'error.OneOfPayments',
  errorChooseAssociation = 'error.ChooseAssociation',
  errorFillInRequiredFields = 'error.FillInRequiredFields',
  errorInvalidPersonalID = 'error.InvalidPersonalID',
  errorExactNumberOfNumbers = 'error.ExactNumberOfChars',
  errorTooLong = 'error.tooLong',
  errorTooShort = 'error.tooShort',
  errorSubmissionError = 'error.SubmissionError',
  errorInvalidBankAccount = 'error.InvalidBankAccount',
  errorConsentRequired = 'error.ConsentRequired',
  errorMismatch = 'error.Mismatch',
  warningInvalidBankAccount = 'warning.InvalidBankAccount',
  formFirstName = 'form.FirstName',
  formFamilyName = 'form.FamilyName',
  formPersonalIdentityNumber = 'form.PersonalIdentityNumber',
  formCoordinationNumber = 'form.CoordinationNumber',
  formStreetName = 'form.StreetName',
  formPostalCode = 'form.PostalCode',
  formCity = 'form.City',
  formCountry = 'form.Country',
  formEmailAddress = 'form.EmailAddress',
  formEmailAddressRepeated = 'form.EmailAddressRepeated',
  formPhoneNumber = 'form.PhoneNumber',
  formMemberCode = 'form.MemberCode',
  headingGreeting = 'heading.Greeting',
  headingEducation = 'heading.Education',
  headingCountry = 'heading.Country',
  headingWork = 'heading.Work',
  headingIncome = 'heading.Income',
  headingAlmostDone = 'heading.AlmostDone',
  headingCorrectInformation = 'heading.CorrectInformation',
  headingFillContactDetails = 'heading.FillContactDetails',
  headingHowToPay = 'heading.HowToPay',
  headingThankYou = 'heading.ThankYou',
  headingOther = 'heading.Other',
  headingMemberCode = 'heading.MemberCode',
  alreadyMemberTitle = 'member.AlreadyMemberTitle',
  alreadyMemberYes = 'member.alreadyMemberYes',
  alreadyMemberNo = 'member.alreadyMemberNo',
  alreadyAEAMember = 'member.alreadyAEAMember',
  questionWhatIsYourMainOccupation = 'question.WhatIsYourMainOccupation',
  questionInWhatCountryDoYouWork = 'question.inWhatCountryDoYouWork',
  questionHowManyEducationPoints = 'question.howManyEducationPoints',
  questionHowManyEducationPointsTooltipContent = 'question.howManyEducationPointsTooltipContent',
  questionDoYouHaveAInternationalEducation = 'question.DoYouHaveAInternationalEducation',
  questionDoYouHaveAInternationalEducationTooltipContent = 'question.DoYouHaveAInternationalEducationTooltipContent',
  questionDoYouWorkAs = 'question.DoYouWorkAs',
  questionHaveYouWorkedBefore = 'question.HaveYouWorkedBefore',
  questionHaveYouWorkedBeforeDescription = 'question.HaveYouWorkedBeforeDescription',
  questionHowDoYouGetPaid = 'question.HowDoYouGetPaid',
  answerIWorkInSweden = 'answer.iWorkInSweden',
  answerIWorkAbroad = 'answer.iWorkAbroad',
  answerIAmSelfEmployeed = 'answer.IAmSelfEmployeed',
  answerIDoNotCurrentlyWork = 'answer.IDoNotCurrentlyWork',
  answerIAmAPostDoc = 'answer.answerIAmAPostDoc',
  answerYes = 'answer.Yes',
  answerNo = 'answer.No',
  answerIStudyWithGoal180 = 'answer.iStudyWithGoal180',
  answerUncertainUniCountryDegree = 'answer.UncertainUniCountryDegree',
  answerUniversity = 'answer.University',
  answerCountry = 'answer.Country',
  answerDegree = 'answer.Degree',
  answerYesInSweden = 'answer.YesInSweden',
  answerYesButAbroad = 'answer.YesButAbroad',
  answerNoNever = 'answer.NoNever',
  answerMarineOfficer = 'answer.MarineOfficer',
  answerMilitaryPersonnel = 'answer.MilitaryPersonnel',
  answerUDStaff = 'answer.UDStaff',
  answerFlightEngineer = 'answer.FlightEngineer',
  answerPrincipal = 'answer.Principal',
  answerQualifiedTeacher = 'answer.CommunicationsOfficer',
  answerOther = 'answer.Other',
  answerOtherDescriptive = 'answer.OtherDescriptive',
  answerIGetASalary = 'answer.IGetASalary',
  answerIGetASalaryAndScholarship = 'answer.IGetASalaryAndScholarship',
  answerIGetOnlyAScholarship = 'answer.IGetOnlyAScholarship.',
  paymentAutogiro = 'payment.Autogiro',
  paymentBankLabel = 'payment.BankLabel',
  paymentBankNumberLabel = 'payment.BankNumberLabel',
  paymentBankHelpText = 'payment.BankHelpText',
  paymentInvoice = 'payment.Invoice',
  paymentInvoiceKivra = 'payment.InvoiceKivra',
  paymentInvoiceKivraLink = 'payment.InvoiceKivraLink',
  paymentViaAssociation = 'payment.ViaAssociation',
  paymentViaAssociationDescription = 'payment.ViaAssociationDescription',
  paymentChooseAssociation = 'payment.ChooseAssociation',
  paymentEInvoiceTitle = 'payment.EInvoiceTitle',
  paymentEInvoiceDescription = 'payment.EInvoiceDescription',
  paymentEInvoiceLink = 'payment.EInvoiceLink',
  paymentDirectDebitTitle = 'payment.DirectDebitTitle',
  paymentDirectDebitDescription = 'payment.DirectDebitDescription',
  paymentDirectDebitLink = 'payment.DirectDebitLink',
  policyLinkTitle = 'login.policyLinkTitle',
  submissionConsent = 'submission.Consent',
  submissionPolicy = 'submission.Policy',
  submissionPolicyLinkTitle = 'submission.PolicyLinkTitle',
  whyBankId = 'login.whyBankId',
  noBankId = 'login.noBankId',
  checkoutSummarySubHeader = 'checkout.summarySubHeader',
  checkoutSummaryHeader = 'checkout.summaryHeader',
  summaryDetails = 'summary.details',
  summaryPayment = 'summary.payment',
  summaryEducation = 'summary.education',
  summaryPOA = 'summary.POA',
  summaryPOAQuestion = 'summary.POAQuestion',
  summaryWork = 'summary.work',
  summaryAccount = 'summary.account',
  submissionErrorBadRequest = 'submission.errorBadRequest',
  memberCodeDescription = 'member.codeDescription',
}

type String = {
  [index in TranslationKey]: string;
};

type Translation = {
  [index in LanguageCode]: String;
};

export const TranslationStrings: Translation = {
  ['en']: {
    [TranslationKey.uiButtonNext]: 'Proceed',
    [TranslationKey.uiButtonBack]: 'Back',
    [TranslationKey.uiButtonGoBack]: 'Go back',
    [TranslationKey.uiStartTitle]: 'We appreciate that you want to join Akademikernas a-kassa',
    [TranslationKey.uiBeginLegimitize]: 'Provide electronic identification to start the process',
    [TranslationKey.uiBeginLegimitizeNoEid]: 'Start the application by filling in the field below',
    [TranslationKey.uiSpecify]: 'Specify',
    [TranslationKey.uiSpecifyCountry]: 'Specify country',
    [TranslationKey.uiPersonalIdNumber]: 'Personal identity number (YYMMDDXXXX)',
    [TranslationKey.cgiSignInTitle]: 'Authenticate with {provider}',
    [TranslationKey.cgiDescription]: 'To complete the login process, click the button below to open the {provider} app.',
    [TranslationKey.cgiSignInProgress]: 'Waiting for you to sign in with {provider}',
    [TranslationKey.cgidAnotherStep1]: '1. Open the {provider} app on your mobile device.',
    [TranslationKey.cgidAnotherStep2]: '2. Scan the QR symbol in the app.',
    [TranslationKey.cgidAnotherStep3]: '3. Authenticate yourself.',
    [TranslationKey.cgiFreja]: 'Freja eID',
    [TranslationKey.cgiBankId]: 'BankID',
    [TranslationKey.uiUnspecifiedError]: 'Oops. Something went wrong.',
    [TranslationKey.uiTryOnAnotherDeviceMessage]: 'Please try on another device if the issue persists.',
    [TranslationKey.uiSubmit]: 'Submit application',
    [TranslationKey.uiEdit]: 'Edit',
    [TranslationKey.uiCancel]: 'Abort',
    [TranslationKey.uiLogin]: 'Log in',
    [TranslationKey.uiOpenCgiApp]: 'Open {provider}',
    [TranslationKey.uiTryAgain]: 'Try again',
    [TranslationKey.uiClickHere]: 'Click here',
    [TranslationKey.headingGreeting]: 'Hi',
    [TranslationKey.headingEducation]: 'Education level',
    [TranslationKey.headingCountry]: 'Country',
    [TranslationKey.headingWork]: 'Work',
    [TranslationKey.headingIncome]: 'Income',
    [TranslationKey.headingAlmostDone]: 'Almost finished',
    [TranslationKey.headingCorrectInformation]: 'Please check that your contact details are correct',
    [TranslationKey.headingFillContactDetails]: 'Fill in your contact details',
    [TranslationKey.headingHowToPay]: 'How would you like to pay?',
    [TranslationKey.headingThankYou]: 'Thank you!',
    [TranslationKey.headingMemberCode]: 'Invited by a friend?',
    [TranslationKey.headingOther]: 'Other',
    [TranslationKey.alreadyMemberTitle]:
      'You are currently a member with {name}. Would you like us to help you switch over to us?',
    [TranslationKey.alreadyMemberYes]: 'Yes. I authorise you to terminate my membership with {name}.',
    [TranslationKey.alreadyMemberNo]: 'No, I will terminate my membership with {name} myself.',
    [TranslationKey.alreadyAEAMember]: 'You are already a member of Akademikernas a-kassa',
    [TranslationKey.questionWhatIsYourMainOccupation]: 'What is your main occupation?',
    [TranslationKey.questionHowManyEducationPoints]: 'Do you hold at least 150 Swedish ECTS?',
    [TranslationKey.questionHowManyEducationPointsTooltipContent]: 'Choose this option if you have a Swedish education of 120 credits before 2007 or if you were previously a member of Akademikernas a-kassa.',
    [TranslationKey.questionInWhatCountryDoYouWork]: 'In which country are you currently employed?',
    [TranslationKey.questionDoYouHaveAInternationalEducation]:
      'Do you hold a foreign (non-Swedish) university degree equivalent to at least 150 ECTS?',
    [TranslationKey.questionDoYouHaveAInternationalEducationTooltipContent]: 'If you have at least a Bachelor\'s degree, it is equivalent to 150 Swedish ECTS.',
    [TranslationKey.questionDoYouWorkAs]: 'Do you work in any of the following professions?',
    [TranslationKey.questionHaveYouWorkedBefore]: 'Have you worked before?',
    [TranslationKey.questionHaveYouWorkedBeforeDescription]:
      'Any paid and taxed employment counts. Just one hour of work is enough for membership.',
    [TranslationKey.questionHowDoYouGetPaid]: 'How are you paid?',
    [TranslationKey.answerIWorkInSweden]: 'I am currently working in Sweden',
    [TranslationKey.answerIWorkAbroad]: 'I am currently working abroad',
    [TranslationKey.answerIAmSelfEmployeed]: 'I am self-employed',
    [TranslationKey.answerIDoNotCurrentlyWork]: 'I do not currently work',
    [TranslationKey.answerIAmAPostDoc]: 'I am a PhD student or Post-doctoral researcher',
    [TranslationKey.answerYes]: 'Yes',
    [TranslationKey.answerNo]: 'No',
    [TranslationKey.answerIStudyWithGoal180]: 'I am currently studying towards 180 ECTS (or equivalent)',
    [TranslationKey.answerUncertainUniCountryDegree]:
      'Not sure? Enter the names of your university, country, and your degree in the fields below',
    [TranslationKey.answerUniversity]: 'University',
    [TranslationKey.answerCountry]: 'Country',
    [TranslationKey.answerDegree]: 'Degree',
    [TranslationKey.answerYesInSweden]: 'Yes, most recently in Sweden',
    [TranslationKey.answerYesButAbroad]: 'Yes, but abroad',
    [TranslationKey.answerNoNever]: 'No, I have never worked before',
    [TranslationKey.answerMarineOfficer]: 'Marine Officer',
    [TranslationKey.answerMilitaryPersonnel]: 'Swedish Military Personnel',
    [TranslationKey.answerUDStaff]: 'Employed by the Swedish Ministry for Foreign Affairs (UD)',
    [TranslationKey.answerFlightEngineer]: 'Flight Engineer',
    [TranslationKey.answerPrincipal]: 'Principal / Headmaster',
    [TranslationKey.answerQualifiedTeacher]: 'Qualified teacher',
    [TranslationKey.answerOther]: 'Other',
    [TranslationKey.answerOtherDescriptive]: 'State what you work as and the reason why your occupation is a graduate occupation.',
    [TranslationKey.answerIGetASalary]: 'I am a salaried employee',
    [TranslationKey.answerIGetASalaryAndScholarship]: 'I receive both a salary and a scholarship',
    [TranslationKey.answerIGetOnlyAScholarship]: 'I only receive a scholarship',
    [TranslationKey.errorRequired]: 'This field cannot be left blank',
    [TranslationKey.errorInvalidEmail]: 'Please enter a valid email address',
    [TranslationKey.errorOneOfPayments]: 'You must select a payment option',
    [TranslationKey.errorChooseAssociation]:
      'Please choose through which trade union (fackförbund) you would like to pay our membership fee',
    [TranslationKey.errorFillInRequiredFields]: 'Please fill in all required fields',
    [TranslationKey.errorInvalidPersonalID]: 'Please enter a valid personal identity number (personnummer)',
    [TranslationKey.errorExactNumberOfNumbers]: 'It has to be exactly {length} digits',
    [TranslationKey.errorTooLong]: `It can't be longer than {length} characters`,
    [TranslationKey.errorTooShort]: `It can't be shorter than {length} caracters`,
    [TranslationKey.errorSubmissionError]:
      'Something went wrong when trying to submit your application. Please make sure the information is correct and try again.',
    [TranslationKey.errorInvalidBankAccount]:
      'There seems to be a problem with your bank details. Did you enter both your clearing and account numbers?',
    [TranslationKey.errorConsentRequired]: 'You must agree to the terms and conditions in order to submit',
    [TranslationKey.errorMismatch]: 'Make sure the value matches the {otherField} field',
    [TranslationKey.warningInvalidBankAccount]: 'We are unable to find a bank that matches your account number. Please check it before submitting.',
    [TranslationKey.formFirstName]: 'First Name',
    [TranslationKey.formFamilyName]: 'Family Name',
    [TranslationKey.formPersonalIdentityNumber]: 'Swedish personal identity number',
    [TranslationKey.formCoordinationNumber]: 'Coordination number',
    [TranslationKey.formStreetName]: 'Street name and number',
    [TranslationKey.formPostalCode]: 'Postal code (postnummer)',
    [TranslationKey.formCity]: 'City or town',
    [TranslationKey.formCountry]: 'Country',
    [TranslationKey.formEmailAddress]: 'Email address',
    [TranslationKey.formEmailAddressRepeated]: 'Repeat email address',
    [TranslationKey.formPhoneNumber]: 'Mobile telephone number',
    [TranslationKey.formMemberCode]: 'Member code',
    [TranslationKey.paymentAutogiro]: 'Automatic payment (autogiro)',
    [TranslationKey.paymentBankLabel]: 'Bank',
    [TranslationKey.paymentBankNumberLabel]: 'Enter your bank details (both clearing and account numbers)',
    [TranslationKey.paymentBankHelpText]: 'Use only numbers, no space or hyphens are allowed',
    [TranslationKey.paymentInvoice]: 'Paper invoice per post or via Kivra',
    [TranslationKey.paymentInvoiceKivra]:
      'If you have registered with the Kivra service, your invoice will be sent there.',
    [TranslationKey.paymentInvoiceKivraLink]: 'More information about the Kivra service (in Swedish).',
    [TranslationKey.paymentViaAssociation]: 'Combined payment through my trade union (fackförbund)',
    [TranslationKey.paymentViaAssociationDescription]:
      'Only the following trade unions offer combined payments. If you are a member of another trade union, you must choose another form of payment. We suggest automatic payments (autogiro).',
    [TranslationKey.paymentChooseAssociation]: 'Select your trade union (fackförbund)',
    [TranslationKey.paymentEInvoiceTitle]: 'Would you like to pay with electronic billing (e-faktura)?',
    [TranslationKey.paymentEInvoiceDescription]:
      'To pay with electronic billing (e-faktura), log in to your Internet banking service and search for "Akademikernas" in the e-faktura section once we have confirmed your membership. Select paper invoice for now.',
    [TranslationKey.paymentEInvoiceLink]: 'More information about electronic billing / e-faktura (in Swedish)',
    [TranslationKey.paymentDirectDebitTitle]: 'Would you like to pay with direct debit (autogiro)?',
    [TranslationKey.paymentDirectDebitDescription]: 'To pay with direct debit (autogiro), log in to your Internet banking service and search for "Akademikernas" in the autogiro section once we have confirmed your membership. Select paper invoice for now.',
    [TranslationKey.paymentDirectDebitLink]: 'More information about direct debit / autogiro (in Swedish)',
    [TranslationKey.policyLinkTitle]: 'More information about how we use your personal data',
    [TranslationKey.submissionConsent]:
      'I hereby certify that I am applying for membership with Akademikernas a-kassa, and that the information I have provided is accurate and complete. I consent to Akademikernas a-kassa colleting details about previous or current membership in other a-kassa organisations.',
    [TranslationKey.submissionPolicy]:
      'We care about your privacy.',
    [TranslationKey.submissionPolicyLinkTitle]: 'Read more about how we use your personal data',
    [TranslationKey.whyBankId]: 'Why do I need to sign in using BankID?',
    [TranslationKey.noBankId]: 'No BankID?',
    [TranslationKey.checkoutSummarySubHeader]: 'Please make sure your answers are correct before submitting the application.',
    [TranslationKey.checkoutSummaryHeader]: 'We are almost done',
    [TranslationKey.summaryDetails]: 'Contact details',
    [TranslationKey.summaryEducation]: 'Education',
    [TranslationKey.summaryPOA]: 'Power of attorney',
    [TranslationKey.summaryPOAQuestion]: 'I authorise you to terminate my membership with {name}.',
    [TranslationKey.summaryPayment]: 'Payment',
    [TranslationKey.summaryWork]: 'Work',
    [TranslationKey.summaryAccount]: 'Account',
    [TranslationKey.submissionErrorBadRequest]: 'There is invalid data in the form. Please make sure all fields are filled and try again.',
    [TranslationKey.memberCodeDescription]: 'Have you received a code from an existing member? Enter it below and we will give you both a free cinema ticket.'
  },
  'sv': {
    [TranslationKey.uiButtonNext]: 'Gå vidare',
    [TranslationKey.uiButtonBack]: 'Tillbaka',
    [TranslationKey.uiButtonGoBack]: 'Gå tillbaka',
    [TranslationKey.uiStartTitle]: 'Vad bra att du vill bli medlem i Akademikernas a-kassa',
    [TranslationKey.uiBeginLegimitize]: 'Legitimera dig för att börja',
    [TranslationKey.uiBeginLegimitizeNoEid]: 'Starta ansökan genom att fylla i fältet nedan',
    [TranslationKey.uiSpecify]: 'Ange',
    [TranslationKey.uiSpecifyCountry]: 'Ange land',
    [TranslationKey.uiPersonalIdNumber]: 'Personnummer (YYMMDDXXXX)',
    [TranslationKey.cgiSignInTitle]: 'Legitimera dig med {provider}',
    [TranslationKey.cgiDescription]:
      'För att logga in, klicka på knappen nedan för att öppna {provider}-appen.',
    [TranslationKey.cgiSignInProgress]: 'Väntar på att du ska logga in med {provider}',
    [TranslationKey.cgidAnotherStep1]: '1. Öppna {provider}-appen i mobilen.',
    [TranslationKey.cgidAnotherStep2]: '2. Skanna QR-koden i appen.',
    [TranslationKey.cgidAnotherStep3]: '3. Legitimera dig själv.',
    [TranslationKey.cgiFreja]: 'Freja eID',
    [TranslationKey.cgiBankId]: 'BankID',
    [TranslationKey.uiUnspecifiedError]: 'Ops, något gick fel.',
    [TranslationKey.uiTryOnAnotherDeviceMessage]: 'Vänligen testa på en annan enhet om problemet kvarstår.',
    [TranslationKey.uiSubmit]: 'Skicka in ansökan',
    [TranslationKey.uiEdit]: 'Redigera',
    [TranslationKey.uiCancel]: 'Avbryt',
    [TranslationKey.uiLogin]: 'Starta legitimering',
    [TranslationKey.uiOpenCgiApp]: 'Öppna {provider}',
    [TranslationKey.uiTryAgain]: 'Försök igen',
    [TranslationKey.uiClickHere]: 'Klicka här',
    [TranslationKey.headingGreeting]: 'Hej',
    [TranslationKey.headingEducation]: 'Utbildning',
    [TranslationKey.headingCountry]: 'Land',
    [TranslationKey.headingWork]: 'Arbete',
    [TranslationKey.headingIncome]: 'Inkomst',
    [TranslationKey.headingAlmostDone]: 'Nästan klara',
    [TranslationKey.headingCorrectInformation]: 'Stämmer dina kontaktuppgifter?',
    [TranslationKey.headingFillContactDetails]: 'Fyll i dina kontaktuppgifter',
    [TranslationKey.headingHowToPay]: 'Hur vill du betala?',
    [TranslationKey.headingThankYou]: 'Tack!',
    [TranslationKey.headingMemberCode]: 'Inbjuden av en vän?',
    [TranslationKey.headingOther]: 'Övrigt',
    [TranslationKey.alreadyMemberTitle]: 'Du är redan med i {name} a-kassa. Vill du att vi ska ordna med bytet?',
    [TranslationKey.alreadyMemberYes]: 'Ja gärna. Jag ger er fullmakt att avsluta mitt medlemskap i {name} a-kassa',
    [TranslationKey.alreadyMemberNo]: 'Nej, jag kommer att själv avsluta medlemskapet i {name} a-kassa',
    [TranslationKey.alreadyAEAMember]: 'Du är redan medlem i Akademikernas a-kassa',
    [TranslationKey.questionWhatIsYourMainOccupation]: 'Vilken är din huvudsakliga sysselsättning?',
    [TranslationKey.questionHowManyEducationPoints]: 'Jag har minst 150 svenska högskolepoäng',
    [TranslationKey.questionHowManyEducationPointsTooltipContent]: 'Välj detta alternativ om du har en utbildning på 120 poäng före 2007 eller om du tidigare varit medlem i Akademikernas a-kassa.',
    [TranslationKey.questionInWhatCountryDoYouWork]: 'I vilket land arbetar du?',
    [TranslationKey.questionDoYouHaveAInternationalEducation]:
      'Har du en utländsk högskoleutbildning som motsvarar 150 svenska högskolepoäng?',
    [TranslationKey.questionDoYouHaveAInternationalEducationTooltipContent]: 'Har du minst en Bachelor motsvarar det 150 svenska högskolepoäng.',
    [TranslationKey.questionDoYouWorkAs]: 'Arbetar du som något av följande?',
    [TranslationKey.questionHaveYouWorkedBefore]: 'Har du arbetat tidigare?',
    [TranslationKey.questionHaveYouWorkedBeforeDescription]:
      'Alla arbeten du betalat skatt för räknas. En timme räcker.',
    [TranslationKey.questionHowDoYouGetPaid]: 'Hur får du betalt?',
    [TranslationKey.answerIWorkInSweden]: 'Jag arbetar i Sverige',
    [TranslationKey.answerIWorkAbroad]: 'Jag arbetar utomlands',
    [TranslationKey.answerIAmSelfEmployeed]: 'Jag är egen företagare',
    [TranslationKey.answerIDoNotCurrentlyWork]: 'Jag arbetar inte just nu',
    [TranslationKey.answerIAmAPostDoc]: 'Jag är doktorand/postdoktorand',
    [TranslationKey.answerYes]: 'Ja',
    [TranslationKey.answerNo]: 'Nej',
    [TranslationKey.answerIStudyWithGoal180]: 'Jag studerar nu med målet 180 högskolepoäng',
    [TranslationKey.answerUncertainUniCountryDegree]: 'Osäker? Ange universitet, land, examen i fälten nedan',
    [TranslationKey.answerUniversity]: 'Universitet',
    [TranslationKey.answerCountry]: 'Land',
    [TranslationKey.answerDegree]: 'Examen',
    [TranslationKey.answerYesInSweden]: 'Ja, senast i Sverige',
    [TranslationKey.answerYesButAbroad]: 'Ja, men utomlands',
    [TranslationKey.answerNoNever]: 'Nej, jag har aldrig arbetat',
    [TranslationKey.answerMarineOfficer]: 'Sjöbefäl',
    [TranslationKey.answerMilitaryPersonnel]: 'Anställd militär personal',
    [TranslationKey.answerUDStaff]: 'UD-personal',
    [TranslationKey.answerFlightEngineer]: 'Flygtekniker',
    [TranslationKey.answerPrincipal]: 'Rektor',
    [TranslationKey.answerQualifiedTeacher]: 'Behörig lärare',
    [TranslationKey.answerOther]: 'Annat',
    [TranslationKey.answerOtherDescriptive]: 'Ange vad du arbetar som och anledningen till att ditt yrke är ett akademikeryrke.',
    [TranslationKey.answerIGetASalary]: 'Jag får lön',
    [TranslationKey.answerIGetASalaryAndScholarship]: 'Jag får lön och stipendium',
    [TranslationKey.answerIGetOnlyAScholarship]: 'Jag får endast stipendium',
    [TranslationKey.errorRequired]: 'Fältet kan inte lämnas tomt',
    [TranslationKey.errorInvalidEmail]: 'Vänligen ange en korrekt emailadress',
    [TranslationKey.errorOneOfPayments]: 'Du måste välja ett betalningsalternativ',
    [TranslationKey.errorChooseAssociation]: 'Vänligen välj ett förbund att betala via',
    [TranslationKey.errorFillInRequiredFields]: 'Vänligen fyll i samtliga nödvändiga fält',
    [TranslationKey.errorInvalidPersonalID]: 'Vänligen fyll i ett giltigt personnummer',
    [TranslationKey.errorExactNumberOfNumbers]: 'Får endast vara {length} siffror',
    [TranslationKey.errorTooLong]: `Får inte vara längre än {length} karaktärer`,
    [TranslationKey.errorTooShort]: `Får inte vara kortare än {length} karaktärer`,
    [TranslationKey.errorSubmissionError]:
      'Något gick fel när vi försökte skicka in din ansökan. Vänligen kolla att din information är korrekt och försök igen.',
    [TranslationKey.errorInvalidBankAccount]:
      'Det verkar inte som att ditt kontonummer stämmer. Har du skrivit in både clearing- och kontonumret?',
    [TranslationKey.errorConsentRequired]: 'Du måste godkänna villkoren för att kunna skicka in',
    [TranslationKey.errorMismatch]: 'Se till att värdet matchar {otherField}-fältet',
    [TranslationKey.warningInvalidBankAccount]: 'Vi lyckas inte hitta en bank som matchar ditt kontonummer. Kontrollera det gärna innan du skickar in.',
    [TranslationKey.formFirstName]: 'Förnamn',
    [TranslationKey.formFamilyName]: 'Efternamn',
    [TranslationKey.formPersonalIdentityNumber]: 'Personnummer',
    [TranslationKey.formCoordinationNumber]: 'Samordningsnummer',
    [TranslationKey.formStreetName]: 'Gatuadress',
    [TranslationKey.formPostalCode]: 'Postnummer',
    [TranslationKey.formCity]: 'Ort',
    [TranslationKey.formCountry]: 'Land',
    [TranslationKey.formEmailAddress]: 'E-postadress',
    [TranslationKey.formEmailAddressRepeated]: 'Upprepa e-postadress',
    [TranslationKey.formPhoneNumber]: 'Mobilnummer',
    [TranslationKey.formMemberCode]: 'Medlemskod',
    [TranslationKey.paymentAutogiro]: 'Autogiro',
    [TranslationKey.paymentBankLabel]: 'Bank',
    [TranslationKey.paymentBankNumberLabel]: 'Ange clearing- och kontonummer',
    [TranslationKey.paymentBankHelpText]: 'Använd endast siffror, inga mellanslag eller bindestreck',
    [TranslationKey.paymentInvoice]: 'Faktura/Kivra',
    [TranslationKey.paymentInvoiceKivra]: 'Har du någon gång använt Kivra kommer din faktura att hamna där.',
    [TranslationKey.paymentInvoiceKivraLink]: 'Mer om Kivra',
    [TranslationKey.paymentViaAssociation]: 'Tillsammans med förbundsavgiften',
    [TranslationKey.paymentViaAssociationDescription]: 'Följande förbund erbjuder detta alternativ',
    [TranslationKey.paymentChooseAssociation]: 'Välj förbund',
    [TranslationKey.paymentEInvoiceTitle]: 'Vill du betala med e-faktura?',
    [TranslationKey.paymentEInvoiceDescription]:
      'Logga in i din din bank och sök efter Akademikernas eller AEA. Anmäl dig sedan där. Under tiden, välj faktura som betalningsmetod.',
    [TranslationKey.paymentEInvoiceLink]: 'Mer om e-faktura',
    [TranslationKey.paymentDirectDebitTitle]: 'Vill du betala med autogiro?',
    [TranslationKey.paymentDirectDebitDescription]: 'Logga in i din din bank och sök efter Akademikernas eller AEA. Anmäl dig sedan där. Under tiden, välj faktura som betalningsmetod.',
    [TranslationKey.paymentDirectDebitLink]: 'Mer om autogiro',
    [TranslationKey.policyLinkTitle]: 'Mer om hur vi hanterar personuppgifter',
    [TranslationKey.submissionConsent]:
      'Jag ansöker om medlemskap i Akademikernas a-kassa och försäkrar att uppgifterna jag lämnat är riktiga och fullständiga. Jag tillåter att Akademikernas a-kassa i förekommande fall hämtar uppgifter om tidigare medlemskap i annan a-kassa.',
    [TranslationKey.submissionPolicy]: 'Vi värnar om din integritet.',
    [TranslationKey.submissionPolicyLinkTitle]: 'Mer om hur vi hanterar personuppgifter',
    [TranslationKey.whyBankId]: 'Varför behöver jag logga in med Mobilt Bank ID?',
    [TranslationKey.noBankId]: 'Har du inte Mobilt Bank ID?',
    [TranslationKey.checkoutSummarySubHeader]: 'Vänligen kontrollera att uppgifterna stämmer innan du skickar in ansökan.',
    [TranslationKey.checkoutSummaryHeader]: 'Då är vi snart klara',
    [TranslationKey.summaryDetails]: 'Kontaktuppgifter',
    [TranslationKey.summaryEducation]: 'Utbildning',
    [TranslationKey.summaryPOA]: 'Fullmakt',
    [TranslationKey.summaryPOAQuestion]: 'Jag ger er fullmakt att avsluta mitt medlemskap i {name} a-kassa',
    [TranslationKey.summaryPayment]: 'Betalning',
    [TranslationKey.summaryWork]: 'Arbete',
    [TranslationKey.summaryAccount]: 'Konto',
    [TranslationKey.submissionErrorBadRequest]: 'Informationen du angav i formuläret är inkorrekt. Vänligen kontrollera den och försök igen.',
    [TranslationKey.memberCodeDescription]: 'Har du fått en kod skickad till dig av en befintlig medlem? Ange den i fältet nedan så bjuder vi er båda på en biobiljett.'
  },
};
